import alphaBlogs from "./AlphaBlogData";

const latestBlog = alphaBlogs[alphaBlogs.length - 1];

const sliders = [
    {
        title: 'Latest YouTube Video',
        description: 'Coming soon',
        titleLink: '',
        link: '',
        isExternal: true,
        image: '/images/blog141.PNG',
        index: 0
    },
    {
        title: 'Latest Development Update',
        description: 'Input buffering',
        link: `#${latestBlog.id}`,
        isExternal: false,
        image: '/images/blog149.PNG',
        index: 1,
    },
];

const socialsArray = [
    {
        color: 'var(--themeCyan)',
        src: '/images/Bluesky_logo_(black).svg',
        alt: 'Bluesky Logo',
        link: 'https://bsky.app/profile/mdr-dev.bsky.social'
    },
    {
        color: 'var(--themeMagenta)',
        src: '/images/instagram.svg',
        alt: 'Instagram Logo',
        scale: '120%',
        link: 'https://www.instagram.com/mdr_dev_insta/'
    },
    {
        color: 'var(--themeYellow)',
        src: '/images/yt.png',
        alt: 'YouTube Logo',
        scale: '80%',
        link: 'https://www.youtube.com/@MDR-Dev-YouTube'
    },
    {
        color: 'var(--contra-background-color)',
        src: '/images/x.png',
        alt: 'X Logo',
        link: 'https://x.com/MDR_DevX',
        scale: '70%'
    },
];

export {sliders, socialsArray};